import React, { useEffect, useState } from "react";
import Select from "react-select";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import "./AdminShowData.css";
import * as XLSX from "xlsx";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import editIcon from "../../../Assests/images/editIcon.png";
import deleteIcon from "../../../Assests/images/delete.png";
import ReactModal from "react-modal";
import Popup from "../../Popup/Popup";
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";

ModuleRegistry.registerModules([AllCommunityModule]);
pdfMake.vfs = pdfFonts.vfs;

const AdminShowData = () => {
  const [rowData, setRowData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [popup, setPopup] = useState({ show: false, message: "", type: "" });
  const [selectedTrek, setSelectedTrek] = useState("All");
  const [quickFilter, setQuickFilter] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  // Sensible defaults for every column: sortable, resizable, and a
  // per-column filter with a floating filter row under the header.
  const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    floatingFilter: true,
    minWidth: 130,
  };
  const [editData, setEditData] = useState([
    {
      trekName: "",
      fullName: "",
      age: "",
      gender: "",
      bloodGroup: "",
      address: "",
      mobile: "",
      email: "",
      pickupPoint: "",
      foodPreference: "Veg",
      medicalCondition: "",
      medicalConditionDetails: "",
      emergencyName: "",
      emerContactNumber: "",
      emergencyRelation: "",
      isPaid: "Unpaid",
    },
  ]);

  let token = sessionStorage.getItem("token");
  const columnDefs = [
    {
      headerName: "S.No.",
      valueGetter: "node.rowIndex + 1",
      width: 90,
      pinned: "left",
      sortable: false,
      filter: false,
    },
    {
      headerName: "Full Name",
      field: "fullName",
      pinned: "left",
      filter: true,
    },
    {
      headerName: "Trek Name",
      field: "trekName",
      pinned: "left",
      filter: true,
    },
    { headerName: "Age", field: "age", filter: true },
    { headerName: "Gender", field: "gender", filter: true },
    { headerName: "Blood Group", field: "bloodGroup" },
    { headerName: "Address", field: "address" },
    { headerName: "Mobile", field: "mobile" },
    { headerName: "Email", field: "email" },
    { headerName: "Pickup Point", field: "pickupPoint" },
    { headerName: "Food Preference", field: "foodPreference" },
    { headerName: "Medical Condition", field: "medicalCondition" },
    { headerName: "Medical Details", field: "medicalConditionDetails" },
    { headerName: "Emergency Name", field: "emergencyName" },
    { headerName: "Emergency Contact No", field: "emerContactNumber" },
    { headerName: "Emergency Relation", field: "emergencyRelation" },
    { headerName: "Payment", field: "isPaid" },
    {
      field: "action",
      headerName: "Action",
      pinned: "right",
      cellRenderer: (params) => {
        return (
          <div className="ButtonDiv">
            <button
              onClick={() => {
                handleOpenEditModal(params.data);
              }}
            >
              <img src={editIcon} alt="" />{" "}
            </button>

            <button
              onClick={() => {
                handleDelete(params.data);
              }}
            >
              <img src={deleteIcon} alt="" />{" "}
            </button>
          </div>
        );
      },
    },
  ];

  const columnOptions = columnDefs
    .filter((col) => col.field)
    .map((col) => ({
      value: col.field,
      label: col.headerName,
    }));

  const [selectedColumns, setSelectedColumns] = useState(columnOptions); // default: all selected

  const fetchApplications = () => {
    // fetch("https://avirtrekkers.com/api/api/auth/getApplication")
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/getApplication`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`, // 🔒 Include token in header
      },
    })
      .then((res) => res.json())
      .then((success) => {
        console.log(success.data);
        const flatData = success.data.flatMap((group) =>
          group.applications.map((application) => ({
            ...application,
            parentId: group._id,
          }))
        );
        console.log("flatData", flatData);
        setRowData(flatData);
        setFilteredData(flatData);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    fetchApplications();
  }, []);

  useEffect(() => {
    if (selectedTrek === "All") {
      setFilteredData(rowData);
    } else {
      setFilteredData(rowData.filter((item) => item.trekName === selectedTrek));
    }
  }, [selectedTrek, rowData]);

  const uniqueTreks = [...new Set(rowData.map((item) => item.trekName))];

  const exportToPDF = () => {
    const selectedFields = selectedColumns.map((col) => col.value);

    const selectedColumnDefs = columnDefs.filter(
      (col) => col.field && selectedFields.includes(col.field)
    );

    const headerRow = selectedColumnDefs.map((col) => col.headerName);

    const rows = filteredData.map((item) =>
      selectedColumnDefs.map((col) => item[col.field] || "")
    );

    const documentDefinition = {
      pageOrientation: "landscape",
      pageSize: "A4",
      content: [
        {
          table: {
            headerRows: 1,
            body: [headerRow, ...rows],
          },
          layout: {
            hLineWidth: (i) => (i === 0 ? 2 : 1),
            vLineWidth: () => 1,
            hLineColor: (i) => (i === 0 ? "black" : "#CCCCCC"),
            vLineColor: () => "#CCCCCC",
            paddingLeft: () => 5,
            paddingRight: () => 5,
            paddingTop: () => 3,
            paddingBottom: () => 3,
          },
        },
      ],
      defaultStyle: {
        fontSize: 7,
      },
    };

    pdfMake.createPdf(documentDefinition).download(`${selectedTrek}.pdf`);
  };

  const exportToExcel = () => {
    const selectedFields = selectedColumns.map((col) => col.value);

    const selectedColumnDefs = columnDefs.filter(
      (col) => col.field && selectedFields.includes(col.field)
    );

    const headerRow = selectedColumnDefs.map((col) => col.headerName);

    const rows = filteredData.map((item) =>
      selectedColumnDefs.map((col) => item[col.field] || "")
    );

    const worksheetData = [headerRow, ...rows];

    // Create worksheet and workbook
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Export to Excel
    XLSX.writeFile(workbook, `Trek Details.xlsx`);
  };

  // handleChange function
  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDelete = async (data) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you really want to delete this application?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });

    if (!result.isConfirmed) return;

    const payload = {
      applicationId: data._id,
      parentId: data.parentId,
    };

    try {
      // const res = await fetch("https://avirtrekkers.com/api/api/auth/deleteApplication", {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/deleteApplication`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Failed to delete application");

      const result = await res.json();
      console.log("Server response:", result);

      setPopup({
        show: true,
        message: "Application deleted successfully!",
        type: "success",
      });

      fetchApplications();
    } catch (error) {
      console.error("Error in deleting application:", error);

      setPopup({
        show: true,
        message: "Something went wrong. Please try again.",
        type: "error",
      });
    }
  };


  const handleOpenEditModal = (data) => {
    setIsOpen(true);
    setEditData(data);
    console.log("data", editData);
  };
  console.log("data123", editData);

  const closeModal = () => setIsOpen(false);

  const editAppData = async () => {
    const payload = {
      applicationId: editData._id,
      parentId: editData.parentId,
      updatedData: editData,
    };

    console.log("payload", payload);

    try {
      const res = await fetch(
        // "https://avirtrekkers.com/api/api/auth/updateApplication",
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/updateApplication`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) {
        throw new Error("Failed to submit application");
      }
      const result = await res.json();
      console.log("Server response:", result);
      setPopup({
        show: true,
        message: "Application submitted successfully!",
        type: "success",
      });
    } catch (error) {
      console.error("Error submitting application:", error);

      setPopup({
        show: true,
        message: "Something went wrong. Please try again.",
        type: "error",
      });
    }
  };

  const paidCount = rowData.filter((r) => r.isPaid === "Paid").length;
  const unpaidCount = rowData.filter((r) => r.isPaid === "Unpaid").length;

  return (
    <div className="AdminShowData">
      {/* Dashboard header */}
      <div className="dashHeader">
        <div>
          <h1>Applications Dashboard</h1>
          <p>Manage trek registrations, generate links, and export data.</p>
        </div>
      </div>

      {/* Summary stat cards */}
      <div className="statGrid">
        <div className="statCard">
          <span className="statLabel">Total Applicants</span>
          <span className="statValue">{rowData.length}</span>
        </div>
        <div className="statCard">
          <span className="statLabel">Treks</span>
          <span className="statValue">{uniqueTreks.length}</span>
        </div>
        <div className="statCard statPaid">
          <span className="statLabel">Paid</span>
          <span className="statValue">{paidCount}</span>
        </div>
        <div className="statCard statUnpaid">
          <span className="statLabel">Unpaid</span>
          <span className="statValue">{unpaidCount}</span>
        </div>
      </div>

      {/* Filter + actions toolbar */}
      <div className="filterRow">
        <div className="filterField searchField">
          <label htmlFor="quickSearch">Search</label>
          <div className="searchInputWrap">
            <span className="searchIcon">🔍</span>
            <input
              id="quickSearch"
              type="text"
              placeholder="Search name, mobile, trek, email…"
              value={quickFilter}
              onChange={(e) => setQuickFilter(e.target.value)}
            />
          </div>
        </div>

        <div className="filterField">
          <label htmlFor="trekFilter">Filter by Trek</label>
          <select
            id="trekFilter"
            value={selectedTrek}
            onChange={(e) => setSelectedTrek(e.target.value)}
          >
            <option value="All">All Treks</option>
            {uniqueTreks.map((name, i) => (
              <option key={i} value={name}>
                {name}
              </option>
            ))}
          </select>
        </div>

        <div className="filterActions">
          <Link to="/register" className="secondaryBtn">
            Add User
          </Link>
        </div>
      </div>

      {/* Export toolbar */}
      <div className="exportRow">
        <div className="exportColumns">
          <label>
            <strong>Columns for PDF / Excel export</strong>
          </label>
          <Select
            isMulti
            options={columnOptions}
            value={selectedColumns}
            onChange={(selected) => setSelectedColumns(selected || [])}
            className="basic-multi-select"
            classNamePrefix="select"
            placeholder="Select columns…"
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
        </div>

        <div className="exportButtons">
          <button className="download-btn" onClick={exportToPDF}>
            Download PDF
          </button>
          <button className="download-btn" onClick={exportToExcel}>
            Download Excel
          </button>
        </div>
      </div>

      {/* Results count */}
      <div className="resultsBar">
        <span className="resultsBadge">
          {selectedTrek === "All" ? "All treks" : selectedTrek}
        </span>
        <span className="resultsCount">
          Showing <strong>{filteredData.length}</strong> of {rowData.length} applicants
        </span>
      </div>

      {/* AG Grid Table */}
      <div
        className="ag-theme-alpine"
        style={{ height: 620, width: "100%" }}
      >
        <AgGridReact
          theme="legacy"
          rowData={filteredData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          quickFilterText={quickFilter}
          pagination={true}
          paginationPageSize={20}
          paginationPageSizeSelector={[10, 20, 50, 100]}
          animateRows={true}
        />
      </div>

      <ReactModal
        isOpen={isOpen}
        onRequestClose={closeModal}
        contentLabel="Popup Modal"
        className="popup-modal"
        overlayClassName="popup-overlay"
        shouldCloseOnOverlayClick={false}
      >
        <div className="personalInfo">
          <div className="formInput">
            <label>
              Full Name <span className="requiredStar">*</span>
            </label>
            <input
              type="text"
              name="fullName"
              value={editData.fullName}
              onChange={handleChange}
            />
          </div>

          <div className="formInput">
            <label>
              Age Group <span className="requiredStar">*</span>
            </label>
            <select name="age" value={editData.age} onChange={handleChange}>
              <option value="">-- Select Age Group --</option>
              <option value="5-8">5-8</option>
              <option value="9-12">9-12</option>
              <option value="13-18">13-18</option>
              <option value="13-25">18-25</option>
              <option value="25-35">25-35</option>
              <option value="35-45">35-45</option>
              <option value="45-55">45-55</option>
              <option value="55+">55+</option>
            </select>
          </div>

          <div className="formInput formInputGender inputFourWidth">
            <label>
              Gender <span className="requiredStar">*</span>
            </label>
            <div className="radioDiv">
              <div>
                <label>Female</label>
                <input
                  type="radio"
                  name="gender"
                  value="Female"
                  checked={editData.gender === "Female"}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label>Male</label>
                <input
                  type="radio"
                  name="gender"
                  value="Male"
                  checked={editData.gender === "Male"}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div className="formInput inputFourWidth">
            <label>
              Blood Group <span className="requiredStar">*</span>
            </label>
            <select
              name="bloodGroup"
              value={editData.bloodGroup}
              onChange={handleChange}
            >
              <option value="">-- Select --</option>
              <option value="A+">A+</option>
              <option value="A-">A-</option>
              <option value="B+">B+</option>
              <option value="B-">B-</option>
              <option value="AB+">AB+</option>
              <option value="AB-">AB-</option>
              <option value="O+">O+</option>
              <option value="O-">O-</option>
            </select>
          </div>

          <div className="formInput">
            <label>Address</label>
            <input
              type="text"
              name="address"
              value={editData.address}
              onChange={handleChange}
            />
          </div>
          <div className="formInput">
            <label>
              Mobile Number <span className="requiredStar">*</span>
            </label>
            <input
              type="text"
              name="mobile"
              value={editData.mobile}
              onChange={handleChange}
            />
          </div>
          <div className="formInput">
            <label>Email Id</label>
            <input
              type="email"
              name="email"
              value={editData.email}
              onChange={handleChange}
            />
          </div>
          <div className="formInput inputFourWidth">
            <label>
              Pickup Point <span className="requiredStar">*</span>
            </label>
            <select
              name="pickupPoint"
              value={editData.pickupPoint}
              onChange={handleChange}
            >
              <option value="">-- Select --</option>
              <option value="Deccan">Deccan</option>
              <option value="Nashik Phata">Nashik Phata</option>
              {/* <option value="Ravet">Ravet</option> */}
              {/* <option value="Chandani Chowk">Chandani Chowk</option> */}
              {/* <option value="Panvel">Lonavala</option> */}
              {/* <option value="Panvel">Panvel</option> */}
            </select>
          </div>
          <div className="formInput inputFourWidth">
            <label>
              Food Preference <span className="requiredStar">*</span>
            </label>
            <select
              name="foodPreference"
              value={editData.foodPreference}
              onChange={handleChange}
            >
              {/* <option value="">-- Select --</option> */}
              <option value="Veg">Veg</option>
              {/* <option value="Fasting Food">Fasting Food</option> */}
              {/* <option value="Non-veg">Non-veg</option> */}
            </select>

            {/* <p
              style={{
                fontSize: "12px",
                marginTop: "6px",
                padding: "6px 8px",
                backgroundColor: "#f8f9fa",
                borderLeft: "3px solid #28a745",
                color: "#333",
                borderRadius: "4px",
                lineHeight: "1.4",
              }}
            >
              <strong>Note:</strong> All meals during the trek will be strictly
              vegetarian. Please select <strong>"Fasting Food"</strong> only if
              applicable.
            </p> */}
          </div>

          <div className="formInput formInputGender">
            <label>
              Do you have any medical conditions?{" "}
              <span className="requiredStar">*</span>
            </label>
            <div className="radioDiv">
              <div>
                <label>Yes</label>
                <input
                  type="radio"
                  name="medicalCondition"
                  value="Yes"
                  checked={editData.medicalCondition === "Yes"}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label>No</label>
                <input
                  type="radio"
                  name="medicalCondition"
                  value="No"
                  checked={editData.medicalCondition === "No"}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          {editData.medicalCondition === "Yes" ? (
            <div className="formInput">
              <label>
                Medical Condition Details{" "}
                <span className="requiredStar">*</span>
              </label>
              <textarea
                name="medicalConditionDetails"
                value={editData.medicalConditionDetails}
                onChange={handleChange}
                placeholder="Describe your condition"
              />
            </div>
          ) : (
            ""
          )}

          <div className="formInput">
            <label>
              Emergency Contact Name <span className="requiredStar">*</span>
            </label>
            <input
              type="text"
              name="emergencyName"
              value={editData.emergencyName}
              onChange={handleChange}
            />
          </div>
          <div className="formInput">
            <label>
              Emergency Contact Number <span className="requiredStar">*</span>
            </label>
            <input
              type="text"
              name="emerContactNumber"
              value={editData.emerContactNumber}
              onChange={handleChange}
            />
          </div>
          <div className="formInput">
            <label>
              Relationship with Emergency Contact{" "}
              <span className="requiredStar">*</span>
            </label>
            <input
              type="text"
              name="emergencyRelation"
              value={editData.emergencyRelation}
              onChange={handleChange}
            />
          </div>
          <div className="formInput">
            <label>
              Payment <span className="requiredStar">*</span>
            </label>
            <select
              name="isPaid"
              value={editData.isPaid}
              onChange={handleChange}
              disabled={editData.isPaid === "Paid"} // disable if Paid
            >
              <option value="Paid">Paid</option>
              <option value="Unpaid">Unpaid</option>
            </select>
          </div>
        </div>
        <div className="modalBtns">
          <button className="closeBtn" onClick={closeModal}>
            Close
          </button>
          <button className="submitBtn" onClick={editAppData}>
            Submit
          </button>
        </div>
      </ReactModal>

      {popup.show && (
        <Popup
          message={popup.message}
          type={popup.type}
          onClose={() => setPopup({ show: false, message: "", type: "" })}
        />
      )}
    </div>
  );
};

export default AdminShowData;
